/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvestmentDetailsViewModel } from './InvestmentDetailsViewModel';
import {
    InvestmentDetailsViewModelFromJSON,
    InvestmentDetailsViewModelFromJSONTyped,
    InvestmentDetailsViewModelToJSON,
} from './InvestmentDetailsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfInvestmentDetailsViewModel
 */
export interface ResultOfInvestmentDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfInvestmentDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfInvestmentDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfInvestmentDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfInvestmentDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfInvestmentDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfInvestmentDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfInvestmentDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {InvestmentDetailsViewModel}
     * @memberof ResultOfInvestmentDetailsViewModel
     */
    data?: InvestmentDetailsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfInvestmentDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfInvestmentDetailsViewModel interface.
 */
export function instanceOfResultOfInvestmentDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfInvestmentDetailsViewModelFromJSON(json: any): ResultOfInvestmentDetailsViewModel {
    return ResultOfInvestmentDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfInvestmentDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfInvestmentDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : InvestmentDetailsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfInvestmentDetailsViewModelToJSON(value?: ResultOfInvestmentDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': InvestmentDetailsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

